// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroCircleFilledSvg from "@fishx/icons-svg/es/asn/EuroCircleFilled";
import FishxIcon from '../components/FishxIcon';

var EuroCircleFilled = function EuroCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleFilledSvg
  }));
};

EuroCircleFilled.displayName = 'EuroCircleFilled';
export default React.forwardRef(EuroCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EuroCircleFilled.js
// module id = 2616
// module chunks = 0